module.exports = __webpack_public_path__ + "img/arbre.8cebd200.svg";